module.exports = __webpack_public_path__ + "static/media/Right legs03.93418512.png";